import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import MomentCore from 'moment';

import {
	makeStyles
} from '@material-ui/core';

import ReadMore from './ReadMore';

const styles = makeStyles(theme => ({
	headings: {
		fontSize: "0.9rem",
		color: theme.palette.grey[600]
	},

	current: {
		fontWeight: 500
	}
}));

function HangoutsChatContent(props) {
	const [htmlContent, setHtmlContent] = useState("");
	const [plainContent, setPlainContent] = useState("");

	let classes = styles(),
		{content, originalContent, readMoreLines} = props;

	useEffect(() => {
		// now storing as json string in db instead of formatted string
		try {
			let json = JSON.parse(originalContent);
			if (json && json.history) {
				json.history.forEach((item, i) => {
					item.date = item.date ? `${(new MomentCore.utc(Date.parse(`${item.date} GMT`)).local()).format("MMM Do @ h:mma")}<br />` : "";
					setHtmlContent(htmlContent => {
						return htmlContent + `<span class='${i === 0 ? classes.current : ""}'><span class='${classes.headings}'>\
								${item.date}${item.participant}\
							</span><br/>\
							${item.content}</span>${i < json.history.length-1 ? "<br/><br/>" : ""}`;
					});
				});
			}
		} catch(e) { // backward compatibility for old chats stored as formatted string
			if (originalContent && originalContent.match(/^On\s#{3}, Anonymized/igm)) {
				setPlainContent(originalContent);
			} else {
				// convert timestamps to local time
				let regEx = new RegExp("^On\\s([0-9][0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9]\\s[0-9][0-9]:[0-9][0-9])\\s", "igm"),
					matches = originalContent && originalContent.match(regEx);

				if (matches && matches.length) {
					let str = originalContent;
					str = matches.reduce((result, match) => {
						let d = new MomentCore.utc(Date.parse(`${match.substring(3).trim()} GMT`)).local();
						return result.replace(match, `On ${d.format("MMM Do @ h:mma")} `);
					}, str);
					setPlainContent(str);
				}
			}
		}

	}, [classes, originalContent]);

	return plainContent ? (
		<ReadMore
			showInline
			lines={readMoreLines}
			originalContent={plainContent}>
			{content}
		</ReadMore>
	) : (
		<ReadMore
			preserveHtml
			lines={readMoreLines}
			html={content}
			htmlEllipsis=""
			originalContent={htmlContent} />
	);
}

HangoutsChatContent.defaultProps = {
	readMoreLines: 7
};

HangoutsChatContent.propTypes = {
	content: PropTypes.string,
	originalContent: PropTypes.string,
	readMoreLines: PropTypes.number
};

export default HangoutsChatContent;